// src/data.js
export default [
  {
    imageUrl: require('./assets/Urban/1-min.jpg'),
    caption: 'طرح هادی شهر نلاس',
    secondaryCaption: 'Nelas city guide plan',
    secondaryImages: [
      {
        imageUrl: require('./assets/Urban/1-min.jpg'),
        description: 'طرح هادی شهر نلاس'
      },
    ]
  },
  {
    imageUrl: require('./assets/Urban/2-min.jpg'),
    caption: 'طرح هادی شهر آواجیق',
    secondaryCaption: 'Avajig city guide plan',
    secondaryImages: [
      {
        imageUrl: require('./assets/Urban/2-min.jpg'),
        description: 'طرح هادی شهر آواجیق'
      },
    ]
  },
  {
    imageUrl: require('./assets/Urban/3-min.jpg'),
    caption: 'طرح تفضیلی شهرک خاوران تبریز',
    secondaryCaption: 'Detailed plan of khavaran settlement',
    secondaryImages: [
      {
        imageUrl: require('./assets/Urban/3-min.jpg'),
        description: 'طرح تفضیلی شهرک خاوران تبریز'
      },
    ]
  },
  {
    imageUrl: require('./assets/Urban/6-min.jpg'),
    caption: 'طرح تفضیلی شهرک صیاد شیرازی',
    secondaryCaption: 'Detailed plan of sayad shirazi settlement',
    secondaryImages: [
      {
        imageUrl: require('./assets/Urban/6-min.jpg'),
        description: 'طرح تفضیلی شهرک صیاد شیرازی'
      },
    ]
  },
  {
    imageUrl: require('./assets/Urban/4-min.jpg'),
    caption: 'طرح تفضیلی گوی مجلسی مراغه',
    secondaryCaption: 'Detailed plan of koi majlesi',
    secondaryImages: [
      {
        imageUrl: require('./assets/Urban/4-min.jpg'),
        description: 'طرح تفضیلی گوی مجلسی مراغه'
      },
    ]
  },
  {
    imageUrl: require('./assets/Urban/5-min.jpg'),
    caption: 'طرح هادی شهر میرآباد',
    secondaryCaption: 'Mirabad city guide plan',
    secondaryImages: [
      {
        imageUrl: require('./assets/Urban/5-min.jpg'),
        description: 'طرح هادی شهر میرآباد'
      },
    ]
  },
  
    
    // Add more data as needed
  ];